import request from './request'
import type { LoginRequest, RegisterRequest, AuthResponse, User, ApiResponse } from '@/types'

export const authApi = {
  // 登录
  async login(data: LoginRequest): Promise<AuthResponse> {
    const response = await request.post<ApiResponse<AuthResponse>>('/auth/login', data)
    return response.data.data
  },

  // 注册
  async register(data: RegisterRequest): Promise<AuthResponse> {
    const response = await request.post<ApiResponse<AuthResponse>>('/auth/register', data)
    return response.data.data
  },

  // 获取当前用户
  async getMe(): Promise<User> {
    const response = await request.get<ApiResponse<User>>('/auth/me')
    return response.data.data
  },
}
